"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TableStatus = void 0;
var TableStatus;
(function (TableStatus) {
    TableStatus["IN_LOBBY"] = "IN_LOBBY";
    TableStatus["UNINITIALIZED"] = "UNINITIALIZED";
    TableStatus["PLAYING_GAME"] = "PLAYING_GAME";
    TableStatus["DEALER_CHOOSING_GAME"] = "DEALER_CHOOSING_GAME";
    TableStatus["SHUTTING_DOWN"] = "SHUTTING_DOWN";
    TableStatus["POST_GAME"] = "POST_GAME";
    TableStatus["ARCHIVED"] = "ARCHIVED";
})(TableStatus || (exports.TableStatus = TableStatus = {}));
//# sourceMappingURL=TableStatus.js.map